enum StorageItem {
    LatestApplications = 'LATEST_APPLICATIONS',
    LatestInstance = 'LATEST_INSTANCE',
    LatestLogin = 'LATEST_LOGIN',
    Language = 'LANGUAGE'
}

export default StorageItem;